import FullWidthBG from './FullWidthBG'

export default FullWidthBG
